<template>
  <div>
    <template v-if="isConfiguring">
      <BeatLoaderPrimary :style="style.loader" />
    </template>
    <template v-else>
      <router-view :key="$route.fullPath" />
    </template>
    <ModalDeleteTenant />
    <ModalDeleteTenantUser />
    <ModalUploadUserImage />
    <ModalHelpPrimary />
    <ModalTenantInvitationPrimary />
    <ModalUpgradeEnterpriseWarning />
  </div>
</template>

<script>
  import ModalDeleteTenantUser from '@modals/modal-delete-tenant-user'
  import ModalUploadUserImage from '@modals/modal-upload-user-image'

  import ApiCurrentTenant from '@js/api/current-tenant'
  import ApiCurrentTenantUser from '@js/api/current-tenant-user'
  import ApiTenantParam from '@js/api/tenant-param'
  import BeatLoaderPrimary from '@modules/v2/loader/beat-loader-primary'
  import ModalDeleteTenant from '@settings/modals/modal-delete-tenant'
  import ModalHelpPrimary from '@modals/modal-help-primary'
  import ModalTenantInvitationPrimary from '@modals/modal-tenant-invitation-primary'
  import ModalUpgradeEnterpriseWarning
    from '@modals/modal-upgrade-enterprise-warning'
  import { initStore } from '@store/utils'
  import { mapGetters, mapState } from 'vuex'

  export default {
    name: 'RootTenantUserView',
    components: {
      ModalDeleteTenantUser,
      ModalUploadUserImage,
      BeatLoaderPrimary,
      ModalDeleteTenant,
      ModalHelpPrimary,
      ModalTenantInvitationPrimary,
      ModalUpgradeEnterpriseWarning,
    },
    data: function () {
      return {
        isConfiguring: true,
        style: {
          loader: {
            height: '100vh',
            width: '100%',
          },
        },
      };
    },
    created: async function () {
      if (!this.tenantDomain) {
        await this.onUnselectTenant();
        return;
      }

      await this.initialize();
    },
    computed: {
      ...mapGetters('auth', ['authorized']),
      ...mapState({
        tenantDomain: state => state.tenant.domain,
      }),
    },
    methods: {
      fetchCurrentTenant: async function () {
        try {
          const api = await new ApiCurrentTenant(this.tenantDomain);
          const res = await api.get();
          await this.$store.commit('tenant/setTenant', res.data);
        } catch (error) {
          this.$store.commit(
            'notification/setWarning',
            'Failed to fetch workspace.',
          );
          throw error;
        }
      },
      fetchCurrentTenantUser: async function () {
        try {
          const api = await new ApiCurrentTenantUser();
          const res = await api.get();
          await this.$store.commit('tenantUser/setTenantUser', res.data);
        } catch (error) {
          this.$store.commit(
            'notification/setWarning',
            'Failed to fetch user.',
          );
          throw error;
        }
      },
      fetchTenantParams: async function () {
        try {
          const api = await new ApiTenantParam();
          const res = await api.get();

          await this.$store.commit(
            'tenantParams/setExperienceTypes',
            res.data.experienceTypes,
          );
          await this.$store.commit(
            'tenantParams/setJobCategories',
            res.data.jobCategories,
          );
        } catch (error) {
          this.$store.commit(
            'notification/setWarning',
            'Failed to fetch workspace params.',
          );
          throw error;
        }
      },
      initialize: async function () {
        try {
          this.isConfiguring = await true;

          await this.fetchCurrentTenant();
          await this.fetchCurrentTenantUser();
          await this.fetchTenantParams();
        } catch (error) {
          await console.error(error);
          await initStore(true);
          await this.$router.push({ name: 'tenants' });
        } finally {
          this.isConfiguring = false;
        }
      },
      onUnselectTenant: async function () {
        try {
          await initStore(true);
          await this.$router.push({ name: 'tenants' });
        } catch (error) {
          console.error(error);
        } finally {
          this.isConfiguring = false;
        }
      },
    },
    watch: {
      tenantDomain: async function (newVal, oldVal) {
        if (newVal) {
          await this.initStore(true, ['tenant']);
          await this.initialize();
          await this.$router.push({ name: 'private-home' });
        } else {
          await this.onUnselectTenant();
        }
      },
    },
  };
</script>
